import {AfterViewInit, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
  selector: 'app-section-scroller',
  imports: [
  ],
  templateUrl: './section-scroller.component.html',
  styleUrl: './section-scroller.component.scss',
  standalone: true
})
export class SectionScrollerComponent implements AfterViewInit, OnDestroy {
  constructor(private deviceService: DeviceDetectorService,) {
  }

  @Input() heightAuto: boolean = false;
  @Input() height = 0;
  isVisible: boolean = true;
  isMobileView: boolean = window.innerWidth < 769;

  ngAfterViewInit() {
    setTimeout(() => {
      this.height = this.section?.nativeElement.children[0].offsetHeight;
    });

    window.addEventListener('resize', () => {
      this.isMobileView = window.innerWidth < 769;
    });
  }

  @ViewChild('section', { static: false }) private section: ElementRef | undefined;

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    if (!this.section) return;

    const rect = this.section.nativeElement.getBoundingClientRect();
    const triggerPoint = this.isMobileView
      ? window.innerHeight * 0.25
      : window.innerHeight * 0.4;

    this.isVisible = rect.top <= triggerPoint;
  }

  ngOnDestroy() {
    window.removeEventListener('resize', () => {});
  }
}
